// extracted by mini-css-extract-plugin
export var close = "privacy-notice-module--close--5f29b";
export var container = "privacy-notice-module--container--9314c";
export var contentContainer = "privacy-notice-module--content-container--dadcd";
export var popupContainer = "privacy-notice-module--popup-container--55cce";
export var titleContainer = "privacy-notice-module--title-container--3a170";